<script lang="ts">
import { defineComponent, h, inject } from 'vue';

import { makeTagProps } from '../../composable';

import {
  makeColumnProps,
  useGrid,
  useBreakpoints,
  getClassNameForFlexBreakpoints,
  getClassNameForGridBreakpoints,
  getClassNameForSpan,
  CssGridSymbol
} from './composable';

export const componentName = 'CdsCol';
export default defineComponent({
  name: componentName,
  props: {
    ...makeTagProps(),
    ...makeColumnProps()
  },
  setup(props, context) {
    const { prefix } = useGrid();
    const { breakpoints } = useBreakpoints(props);

    const enableCssGrid = inject(CssGridSymbol, false);
    const containerClassName = enableCssGrid ? `${prefix}--css-grid-column` : `${prefix}-col`;
    const spanClassName = enableCssGrid ? getClassNameForSpan(props.span, prefix) : '';
    const columnClassName = enableCssGrid
      ? getClassNameForGridBreakpoints(breakpoints as any, prefix)
      : getClassNameForFlexBreakpoints(breakpoints, prefix);

    return () =>
      h(
        props.tag,
        {
          class: {
            [containerClassName]: enableCssGrid || columnClassName.length === 0,
            [columnClassName]: !!columnClassName,
            [spanClassName]: !!spanClassName
          }
        },
        context.slots.default && context.slots.default()
      );
  }
});
</script>
